module.exports = __webpack_public_path__ + "static/media/LEVEL3_PROGRESS.84ae3825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/LEVEL3_PROGRESS.png
// module id = 246
// module chunks = 0